import { render, staticRenderFns } from "./OperaLabelsWindow.vue?vue&type=template&id=f8d55bd0&scoped=true&"
import script from "./OperaLabelsWindow.vue?vue&type=script&lang=js&"
export * from "./OperaLabelsWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaLabelsWindow.vue?vue&type=style&index=0&id=f8d55bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8d55bd0",
  null
  
)

export default component.exports